const TRUST_ITEMS = [
  {
    icon: 'ri-shield-check-fill',
    title: 'Licensed & Insured',
    desc: 'Fully licensed, bonded, and insured for your complete peace of mind.',
    badge: 'Verified',
    color: 'text-sage',
    bg: 'bg-sage/12',
    accent: 'bg-sage',
  },
  {
    icon: 'ri-fingerprint-line',
    title: 'Background Checked',
    desc: 'Every caregiver passes rigorous screening and reference checks before hire.',
    badge: 'Screened',
    color: 'text-gold',
    bg: 'bg-gold/12',
    accent: 'bg-gold',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Personalized Plans',
    desc: 'Every care plan is individually crafted — never a one-size-fits-all template.',
    badge: 'Custom',
    color: 'text-sage',
    bg: 'bg-sage/12',
    accent: 'bg-sage',
  },
  {
    icon: 'ri-star-fill',
    title: '5-Star Rated Care',
    desc: 'Consistently rated 5 stars by the families we have had the honor to serve.',
    badge: '5-Star',
    color: 'text-gold',
    bg: 'bg-gold/12',
    accent: 'bg-gold',
  },
];

export default function TrustBar() {
  return (
    <section className="py-0 relative z-10">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="bg-white rounded-2xl -mt-14 grid grid-cols-2 lg:grid-cols-4 overflow-hidden border border-gray-100/80"
          style={{ boxShadow: '0 4px 50px rgba(15,42,68,0.10)' }}
        >
          {TRUST_ITEMS.map((item, i) => (
            <div
              key={i}
              className={`flex flex-col items-center text-center px-6 py-9 gap-3 relative group transition-all hover:bg-[#F7F9F8] ${
                i < TRUST_ITEMS.length - 1 ? 'border-r border-gray-100' : ''
              }`}
            >
              {/* Top accent line */}
              <div className={`absolute top-0 left-1/2 -translate-x-1/2 w-12 h-0.5 ${item.accent} rounded-full opacity-0 group-hover:opacity-100 transition-opacity`} />
              
              <div className="relative">
                <div className={`w-14 h-14 flex items-center justify-center rounded-full ${item.bg} group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} text-2xl ${item.color}`}></i>
                </div>
                <span className="absolute -top-1.5 -right-1.5 bg-navy text-white text-[8px] font-bold px-1.5 py-0.5 rounded-full leading-none uppercase tracking-wide">
                  {item.badge}
                </span>
              </div>

              <div>
                <p className="font-heading font-bold text-navy text-sm mb-1.5 leading-tight">{item.title}</p>
                <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
